export interface CheckBoxType {
  labelText: string;
  value: boolean;
  setValue: React.Dispatch<React.SetStateAction<boolean>>;
}

const CheckBox = ({ setValue, value, labelText }: CheckBoxType) => {
  return (
    <button
      className="flex items-center gap-2 cursor-pointer"
      onClick={() => setValue(!value)}
      type={"button"}
    >
      <div
        className={`sm:w-[12px] md:w-[14px] sm:h-[12px] md:h-[14px] rounded-sm ${
          value ? "bg-violet-500 border-violet-500" : "bg-none border-slate-500"
        } text-white flex justify-center items-center border`}
      >
        {value && <i className="fa-solid fa-check text-[10px]"></i>}
      </div>
      <p className="text-slate-500 md:text-base sm:text-sm">{labelText}</p>
    </button>
  );
};

export default CheckBox;
